import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'
import { message } from 'antd'
import { useTranslation } from 'react-i18next'

export const useSendActivationSurvey = (currentSurvey, sociogramId) => {
  const i18n = useTranslation()
  const surveyId = currentSurvey?.id
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async ({ data }) => {
      const client = await getApi('sociogram', { authenticated: true, version: 4 })
      const response = await client.put(`/surveys/${surveyId}`, data)
      return response.data
    },
    onError: (error, variables) => {
      const { action } = variables
      const statusCode = error?.response?.status

      if (statusCode === 400 && action === 'active') {
        message.error(
          i18n.t('pages.data.sociogram.activeSociogramEce.activationSurveyModal.notEnoughtParticipantsError'),
          [5]
        )
      }

      if (statusCode === 400 && action === 'finish') {
        message.error(
          i18n.t('pages.data.sociogram.activeSociogramEce.completionSurveyModal.notEnoughtParticipantsTerminatedError'),
          [5]
        )
      }
    },
    onSuccess: (_, variables) => {
      const { action } = variables

      // Mensaje dinámico según la acción
      if (action === 'active') {
        message.success(
          i18n.t('pages.data.sociogram.activeSociogramEce.activationSurveyModal.success.message'),
          [3]
        )
      } else {
        message.success(
          i18n.t('pages.data.sociogram.activeSociogramEce.completionSurveyModal.success.message'),
          [3]
        )
      }

      // Invalidar caches sólo si se pasa sociogramId
      if (sociogramId) {
        queryClient.invalidateQueries(['sociogramById', sociogramId])
        queryClient.invalidateQueries(['sociogram', 'surveysBySociogramId', sociogramId])
      }
      // Siempre invalidar recomendaciones (si existen)
      queryClient.invalidateQueries(['schools', 'organizationRecommendations'])
    }
  })

  return {
    isLoading: mutation.isPending,
    dataResponseSurvey: mutation.data,
    updateSurveySociogram: mutation.mutateAsync
  }
}
